module.exports = {"341881001":"西津街道","341881002":"南山街道","341881003":"河沥街道","341881004":"汪溪街道","341881005":"竹峰街道","341881100":"港口镇","341881101":"梅林镇","341881102":"中溪镇","341881103":"宁墩镇","341881104":"仙霞镇","341881105":"甲路镇","341881106":"胡乐镇","341881107":"霞西镇","341881200":"云梯畲族乡","341881201":"南极乡","341881202":"万家乡","341881203":"青龙乡","341881204":"方塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341881.json
// module id = 1064
// module chunks = 0